var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v("Merge Fields")]),_vm._v(" "),_c('ul',_vm._l((_vm.mergeFields),function(field){return _c('li',{key:field},[_vm._v("\n      "+_vm._s('{' + field + '}')+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }